import { useRef, useState, useEffect } from 'react';

const LazyImage = ({ src, alt, className = '', classNameImg, ...props }) => {
  const imgRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

   useEffect(() => {
      const img = new Image();
      img.src = src;
      img.onload = () => setIsLoaded(src);
    }, [src]);

  return (
    <div className={`relative ${className}`}>
      {/* Shimmer loader until image is fully loaded */}
      {!isLoaded && <div className="shimmer-overlay absolute inset-0 rounded" />}
      {/* Image loads only when visible */}
      {isLoaded && (
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          className={`${classNameImg} transition-opacity duration-500 ease-in-out ${
            isLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          {...props}
        />
      )} 
    </div>
  );
};

export default LazyImage;
